<template>
  <v-card>
    <v-card-title>
      <span class="title">Generate Report</span>
    </v-card-title>
    <v-card-text>
      <v-container class="pa-1">
        <v-layout row wrap>
          <v-flex xs4 align-self-center>
            <div>
              Report Title
            </div>
          </v-flex>
          <v-flex xs8>
            <v-text-field 
              v-model="title"
              hide-details
            ></v-text-field>
            <span 
              :class="{hidden: formErrors.title.isValid}"
              class="error-message"
            >
              {{ formErrors.title.message }}
            </span>
          </v-flex>
          <v-flex xs12>
            <br>
          </v-flex>
          <v-flex xs4 align-self-center>
            <div>
              Date Range
            </div>
          </v-flex>
          <v-flex xs8>
            <el-date-picker
              v-model="daterange"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              align="center"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :editable="false"
            ></el-date-picker>
            <span 
              :class="{hidden: formErrors.daterange.isValid}"
              class="error-message"
            >
              {{ formErrors.daterange.message }}
            </span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" flat @click="cancel">Cancel</v-btn>
      <v-btn color="primary" flat @click="generate">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "GenerateReportForm",

  props: [ "report", "show" ],

  data() {
    return {
      daterange: [],

      title: "",

      formErrors: {
        title: {
          isValid: true,
          message: "Title field is required."
        },
        daterange: {
          isValid: true,
          message: "Date Range field is required."
        }
      }
    };
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    generate() {
      if (this.isFormValid()) {
        this.$emit("generate", { 
          title: this.title, 
          daterange: this.daterange,
        });
      }
    },

    isFormValid() {
      this.formErrors.title.isValid = this.title != undefined && this.title.trim() != "";
      this.formErrors.daterange.isValid = this.daterange != undefined && this.daterange.length == 2;
      return this.formErrors.title.isValid && this.formErrors.daterange.isValid;
    },
  },

  watch: {
    show() {
      this.title = this.report.name;
      this.daterange = [];
      this.formErrors.title.isValid = true;
      this.formErrors.daterange.isValid = true;
    },
  },
}
</script>

<style scoped>
.error-message {
  color: #F44336;
  font-size: 12px;
}

.error-message.hidden {
  visibility: hidden;
}
</style>